function tabPanelProps(index) {
    return {
        id: `vertical-tabpanel-${index}`,
        'aria-labelledby': `vertical-tab-${index}`,
    };
}

export default tabPanelProps;